import api from '../api';
import base from '../api/base';

// 上传
const configUrl = {
  uploadUrl: 'https://testapi.chinachdu.com/cloud/doctoruser/oss/api/file/store/v1/saveFile',
  uploadPackage: base.baseUrl + '/cloud/doctoruser/oss/api/file/store/v1/uploadChatFile',
  uploadZFB: base.baseUrl + '/mchchan/crt_upload',
};

const install = Vue => {
  Vue.prototype.$api = api;
  Vue.prototype.$configUrl = configUrl;
};

export default install;
